import assign from 'lodash/assign';

export default function formatPostObject(config) {
  const {
    props,
    post,
    imgSize,
    allowNoImage = true,
    bigStory = false
  } = config;
  let formattedPost = {
    currentSite: props.currentSite,
    bigStory,
    assetSizes: imgSize,
    allowNoImage,
    noLazy: true
  };

  formattedPost = assign(formattedPost, post, {
    excerpt: ''
  });

  return formattedPost;
}



// WEBPACK FOOTER //
// ./src/utils/format_post_object.js